import styled from 'styled-components';

import { OptProps } from './interface';

export const Container = styled.div`
  width: 340px;
  height: 100%;
  position: fixed;
  padding: 0px;
  left: 0px;
  top: 0px;
  background-color: ${({ theme }) => theme.colors.BG2};
  border-right: ${({ theme }) => `3px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  padding: 0rem;

  &.menu-closed {
    width: 50px !important;
  }

  .menu-mobile-show {
    display: flex;
  }
  .menu-mobile-hide {
    display: flex;
  }

  @media (max-width: 1024px) {
    width: 100%;

    &.menu-closed {
      width: 100% !important;
    }

    &.mobile-show {
      height: 100%;
    }

    &.mobile-hide {
      height: auto;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  border-bottom: none;
  border-top: none;
  overflow-y: auto;
  min-height: 100%;

  @media (max-width: 1024px) {
    margin-top: 0rem;
    padding: 0 0 1rem 0;

    &.menu-mobile-hide {
      display: flex;
    }

    &.menu-mobile-hide {
      display: none;
    }
  }
`;

export const GlobalAreaVisible = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  border-bottom: none;
  border-top: none;
  overflow-y: auto;
  min-height: 100%;
`;

export const CollapseMenu = styled.div`
  display: flex;
  width: 100%;
  float: left;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: -50px;
  position: relative;
  z-index: 4000;

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;

    &:hover {
      opacity: 0.5;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Mobile = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    padding: 10px;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.colors.BG2};
    border-right: ${({ theme }) => `3px solid ${theme.colors.BORDER}`};
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
    height: 4rem;

    div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 0;
      flex: 1;

      img {
        float: left;
        height: auto;
        max-width: 150px;
        margin: 5px 0 0 0;
      }

      h1 {
        font-size: 8px;
        font-weight: 700;
        text-transform: uppercase;
        background: ${({ theme }) => theme.colors.LIGHT1};
        color: ${({ theme }) => theme.colors.TEXT1};
        border-radius: 5px;
        padding: 3px;
        margin: -5px 0 0 20px;
      }
    }

    button {
      background: none !important;
    }
  }

  button {
    background: none;
    margin-left: 10px;
  }
`;

export const Header = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 1rem;
  align-items: center;

  @media (max-width: 1024px) {
    background: ${({ theme }) => theme.colors.LIGHT1};
    padding: 0px 10px;

    .theme-btn {
      display: none !important;
    }
  }
`;

export const Connection = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 15px 15px 15px;

  background: ${({ theme }) => theme.colors.LIGHT1};

  main {
    float: left;
    width: 100%;
    display: flex;
    flex-direction: row;
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 6px;
    padding: 10px;

    i {
      margin: 0 5px 0 0;
    }

    div {
      float: left;
      width: 100%;
      display: flex;
      flex-direction: column;

      h1 {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.TEXT1};
      }

      h2 {
        font-size: 10px;
        color: #ccc;
      }
    }
  }

  &.online {
    h2 {
      color: ${({ theme }) => theme.colors.TEXT3};
    }
  }

  &.offline {
    main {
      border-color: rgba(2228, 8, 8, 0.5);
    }
    h2 {
      color: rgba(233, 24, 24, 1) !important;
    }
  }
`;

export const LogoClient = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  float: left;
  width: 100%;
  padding: 3rem 0;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    img {
      background: ${({ theme }) => theme.colors.LIGHT1};
    }
  }

  img {
    transition: all 0.4s ease;
    padding: 10px;
    border-radius: 10px;
    max-width: 14rem;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Ic = styled.div`
  float: left;
  background: ${({ theme }) => theme.colors.COLOR_1};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  div {
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      float: left;
      width: 100%;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const AppName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 20px;
  background: ${({ theme }) => theme.colors.LIGHT4};
  color: ${({ theme }) => theme.colors.TEXT1};
  padding: 20px;
  font-weight: 700;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Information = styled.div`
  padding: 0px 0px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0rem;
  flex: 1;

  h1 {
    font-size: 12px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-weight: 700;
    text-align: left;
  }

  p {
    font-size: 0.7rem;
    color: ${({ theme }) => theme.colors.TEXT1};
    text-align: left;
    padding: 0rem;
    opacity: 0.6;
  }

  button {
    background: ${({ theme }) => theme.colors.LIGHT1};
    padding: 5px;
    border-radius: 5px;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    transition: all 0.5s ease;
    cursor: pointer;
    margin: 0.2rem 0 0 0;

    &:hover {
      background: ${({ theme }) => theme.colors.LIGHT5};
      text-decoration: underline;
    }
  }

  @media (max-width: 1024px) {
    padding: 15px 5px 15px 5px;
    flex-direction: row;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-size: 12px;
      padding: 0px;
    }

    button {
      font-size: 10px;
      margin: 0px;
      padding: 5px;
    }
  }
`;

export const Opts = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  float: left;
  margin-top: 0px;
  flex: 1;
  padding: 15px;

  @media (max-width: 1024px) {
    flex: 0;
    background: ${({ theme }) => theme.colors.LIGHT1};
    padding: 0px;
  }
`;

export const Opt = styled.button<OptProps>`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  cursor: pointer;
  padding: 0px 10px;

  background-color: ${({ active, isSub, theme }) =>
    active
      ? isSub
        ? `${theme.colors.MENU_SUBACTIVE} !important`
        : `${theme.colors.MENU_ACTIVE} !important`
      : theme.colors.LIGHT4};

  transition: all 0.5s ease;
  border-radius: 10px;
  margin: 0 0 5px 0;

  &:hover {
    background: ${({ theme }) => theme.colors.LIGHT1};
  }

  i {
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      fill: ${({ active, theme }) =>
        active ? theme.colors.TEXT2 : theme.colors.TEXT1};
    }

    .ic-custom {
      color: ${({ active, theme }) =>
        active ? theme.colors.TEXT2 : theme.colors.TEXT1};
    }
  }

  span {
    color: ${({ active, theme }) =>
      active ? theme.colors.TEXT2 : theme.colors.TEXT1};
    flex: 1;
    font-size: 14px;
    display: flex;
  }

  @media (max-width: 1024px) {
    height: 45px;
    border-radius: 0px;

    span {
      font-size: 10px;
    }
  }
`;

export const SubOpt = styled.button<OptProps>`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  padding: 10px 0px 10px 20px;
  transition: all 0.5s ease;
  background: none;

  span {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 14px;
    text-align: right;
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 1024px) {
  }
`;

export const MobileAccount = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  border-top: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  padding: 15px 0;
  background: ${({ theme }) => theme.colors.LIGHT6};

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 3px 0;
    cursor: pointer;
    transition: all 0.5s ease;
    border-radius: 8px;
    padding: 5px;

    &:hover {
      background: ${({ theme }) => theme.colors.LIGHT7};
    }

    i {
      margin: 0 5px 0 0;
    }

    div {
      display: flex;
      flex-direction: column;
    }

    span {
      color: #ff7a2e;
      font-size: 10px;
      cursor: pointer;
      font-weight: 700;
    }

    small {
      color: ${({ theme }) => theme.colors.TEXT3};
      font-size: 8px;
    }
  }

  h5 {
    color: ${({ theme }) => theme.colors.TEXT3};
    font-size: 6px;
    font-weight: 700;
    background: ${({ theme }) => theme.colors.LIGHT7};
    padding: 5px;
    border-radius: 5px;
    text-transform: uppercase;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NotificationCount = styled.button.attrs({
  type: 'button',
})`
  float: left;
  background: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.LIGHT2};
  }

  strong {
    background: #000;
    color: ${({ theme }) => theme.colors.TEXT2};
    font-size: 12px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -10px 0 0 -12px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const ThemeBtn = styled.button.attrs({
  type: 'button',
})`
  float: left;
  background: none;
  transition: all 0.5s ease;
  margin: 0 5px;

  &:hover {
    opacity: 0.7;
    transform: rotate(-180deg);
  }
`;

export const Download = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  border-top: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  padding: 15px;
  background: ${({ theme }) => theme.colors.LIGHT6};
  display: none;

  button {
    background: ${({ theme }) => theme.colors.ORANGE};
    float: left;
    border-radius: 8px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;

    &:hover {
      background: ${({ theme }) => theme.colors.BTNBG};
    }

    i {
      margin-right: 10px;
    }

    span {
      font-size: 10px;
      color: ${({ theme }) => theme.colors.TEXT2};
    }
  }

  @media (max-width: 1024px) {
    display: flex;
    align-self: flex-start;
    padding: 20px;
    border-top: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    background: ${({ theme }) => theme.colors.LIGHT6};
  }
`;

export const ICAbc = styled.ins`
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.IC1};
  margin: 0px;
  padding: 0px;
  transform: rotate(-5deg) translateY(2px);
`;

export const CacheTime = styled.div`
  float: left;
  width: 100%;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  flex-direction: row;

  div {
    display: flex;
    flex-direction: column;
    margin: 0 0 0 10px;

    p {
      display: flex;
      flex-direction: row;
      margin: 0 0 2px 0;
    }

    p.info1 {font-size: 14px;}
    p.info2 {font-size: 10px;}
    p.info3 {font-size: 8px;}

  }
`;
